import axios from 'axios';

export default function barracudaStatus(domain) {
  axios.post('/clientarea.php', {
    action: 'getBarracudaStatus',
    domain: domain
  }).then(function (response) {
    if (response.data && response.data.success) {
      $('.barracuda-status').addClass('success');
    } else {
      $('.barracuda-status').addClass('danger');
      $('.barracuda-status').find('.danger__content').html(response.data.data.error);
    }
  }).catch(function (error) {
    console.log(error);
  });
}



// WEBPACK FOOTER //
// ./scripts/components/barracuda_status.js